import React from "react";
import ThankYou from "../../components/ThankYou/ThankYou";

const RegistrationThankyou = () => {
  return (
    <>
      <ThankYou />
    </>
  );
};

export default RegistrationThankyou;
